<template>
  <div class="mobile-popover-container">
    <!-- 触发元素 -->
    <div 
      class="trigger" 
      @click.prevent="togglePopover"
      ref="trigger"
    >
      <slot name="trigger"></slot>
    </div>

    <!-- 弹窗内容 -->
    <transition name="fade">
      <div 
        v-if="visible"
        class="popover-content"
        :class="[placement]"
        :style="popoverStyle"
        style="right: 20px;"
        ref="popover"
      >
        <!-- 箭头 -->
        <div class="popover-arrow" :class="[placement]"></div>
        
        <!-- 内容插槽 -->
        <div class="popover-inner">
          <slot name="content"></slot>
        </div>
      </div>
    </transition>

    <!-- 遮罩层 -->
    <div 
      v-show="visible"
      class="popover-mask" 
      @click="closePopover"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'MobilePopover',
  props: {
    placement: {
      type: String,
      default: 'bottom',
      validator: value => ['top', 'bottom', 'left', 'right'].includes(value)
    }
  },
  data() {
    return {
      visible: false
    }
  },
  computed: {
    popoverStyle() {
      if (!this.visible) return {}
      
      const triggerRect = this.$refs.trigger.getBoundingClientRect()
      const popover = this.$refs.popover
      const popoverRect = popover ? popover.getBoundingClientRect() : { width: 0, height: 0 }
      
      // 根据位置计算弹窗定位
      const position = { top: 0 }
      const offset = 10 // 箭头高度 + 间距
      
      switch (this.placement) {
        case 'top':
          position.top = triggerRect.top - popoverRect.height - offset
          // position.left = triggerRect.left + (triggerRect.width - popoverRect.width) / 2
          break
        case 'bottom':
          position.top = triggerRect.bottom + offset
          // position.left = triggerRect.left + (triggerRect.width - popoverRect.width) / 2
          break
        // case 'left':
        //   position.top = triggerRect.top + (triggerRect.height - popoverRect.height) / 2
        //   // position.left = triggerRect.left - popoverRect.width - offset
        //   break
        case 'right':
          position.top = triggerRect.top + (triggerRect.height - popoverRect.height) / 2
          position.right = 20
          break
      }
      
      // 边界检查（防止超出屏幕）
      // position.left = Math.max(10, Math.min(position.left, window.innerWidth - popoverRect.width - 10))
      position.top = Math.max(10, Math.min(position.top, window.innerHeight - popoverRect.height - 10))
      
      return {
        top: `${position.top}px`,
        // left: `${position.left}px`
      }
    }
  },
  methods: {
    togglePopover() {
      
      if(this.visible){
        this.visible = false
      }else{
        this.visible = true
      }
      console.log(this.visible);
      // this.visible = !this.visible
    },
    closePopover() {
      this.visible = false
    },
    handleClickOutside(e) {
      console.log(e);
      
      if (this.visible && 
          !this.$refs.trigger.contains(e.target) && 
          !this.$refs.popover.contains(e.target)) {
        this.closePopover()
      }
    }
  },
  watch: {
    // visible(val) {
    //   if (val) {
    //     document.addEventListener('click', this.handleClickOutside)
    //     // 移动端添加触摸事件
    //     document.addEventListener('touchend', this.handleClickOutside)
    //   } else {
    //     document.removeEventListener('click', this.handleClickOutside)
    //     document.removeEventListener('touchend', this.handleClickOutside)
    //   }
    // }
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside)
    document.removeEventListener('touchend', this.handleClickOutside)
  }
}
</script>

<style scoped>
.mobile-popover-container {
  position: relative;
  display: inline-block;
}

/* 触发元素 */
.trigger {
  display: inline-block;
}

/* 弹窗容器 */
.popover-content {
  position: absolute;
  z-index: 2000;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid #eee;
  width: 272px;
  padding: 12px 4px;
  box-sizing: border-box;
  right: 5px!important;
    top: 56px!important;
}

/* 弹窗内部内容 */
.popover-inner {
  position: relative;
  z-index: 1;
}

/* 箭头样式 */
.popover-arrow {
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;
}

/* 底部箭头 */
.popover-content.bottom .popover-arrow {
  top: -10px;
  right: 6px;
  transform: translateX(-50%);
  border-width: 0 8px 10px 8px;
  border-color: transparent transparent #f5f5f5 transparent;
  
}

/* 顶部箭头 */
.popover-content.top .popover-arrow {
  bottom: -10px;
  right: 6px;
  transform: translateX(-50%);
  border-width: 10px 8px 0 8px;
  border-color: #fff transparent transparent transparent;
  
}

/* 左侧箭头 */
.popover-content.left .popover-arrow {
  top: 50%;
  right: 20px;
  transform: translateY(-50%);
  border-width: 8px 0 8px 10px;
  border-color: transparent transparent transparent #fff;
}

/* 右侧箭头 */
.popover-content.right .popover-arrow {
  top: 50%;
  left: -10px;
  transform: translateY(-50%);
  border-width: 8px 10px 8px 0;
  border-color: transparent #fff transparent transparent;
}

/* 遮罩层 */
.popover-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: transparent;
  z-index: 1999;
}

/* 过渡动画 */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
</style>


// WEBPACK FOOTER //
// src/components/mode/MobilePopover.vue